<template>
    <div class="clients view-container">
        <div class="view-content">
            <div class="header">
                <ActionBar
                    style="width: 100%"
                    title="Clientes"
                    :showSearchIcon="true"
                    search-field="plannerCode"
                    @search-item="(filter) => (filters = filter)"
                />

                <button
                    class="login-btn"
                    data-cy="planner-login"
                    type="button"
                    :reverse="true"
                    @click="plannerLogin"
                    width="100%"
                >
                    Continuar com sua conta
                </button>
            </div>

            <Sidebar :hideMainMenu="true" />

            <clients-list :data="clients" @open-modal="openModal" />

            <confirmation-modal-generic v-if="modalData.show" v-bind="modalData" @close-modal="closeModal">
                <template #buttons>
                    <basic-button v-if="!modalData.error" :loading="loading" label="Sim" width="100%" @click="login" />

                    <basic-button
                        style="margin-top: 10px"
                        :label="modalData.error ? 'Ok' : 'Não'"
                        :reverse="true"
                        width="100%"
                        :disabled="loading"
                        @click="closeModal"
                    />
                </template>
            </confirmation-modal-generic>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref, computed } from 'vue'
import { useRouter } from 'vue-router'

import { mainStore } from '../store'

import ActionBar from '../components/ActionBar.vue'
import BasicButton from '../components/buttons/BasicButton.vue'
import ClientsList from '../components/lists/ClientsList.vue'
import ConfirmationModalGeneric from '../components/modals/confirmation-modals/ConfirmationModalGeneric.vue'
import Sidebar from '../components/Sidebar.vue'

import authService from '../services/auth.service'

const store = mainStore()

const router = useRouter()

const modalData = ref({
    show: false,
    error: false,
    clientId: '',
    message: '',
})

const loading = ref(false)
const filters = ref(null)

const clients = computed(() => {
    return store.filterClients(filters.value)
})
const plannerLoginData = computed(() => {
    return store.plannerLogin.plannerLoginData
})
const credentials = computed(() => {
    return store.plannerLogin.credentials
})

function plannerLogin() {
    authService.saveDataAndLogin(plannerLoginData.value)
}

function openModal(clientId) {
    const client = clients.value.find((client) => client._id === clientId)

    modalData.value = {
        show: true,
        message: `Deseja logar na conta do cliente ${client.name} (${client.email})`,
        clientId,
    }
}

function closeModal() {
    modalData.value = {
        error: false,
        clientId: '',
        message: '',
        show: false,
    }
}

function login() {
    loading.value = true

    authService
        .authenticate({ ...credentials.value, clientId: modalData.value.clientId })
        .then((status) => {
            let message = ''

            switch (status) {
                case 500:
                    message = 'Erro ao tentar efetuar login'
                    modalData.value.error = true
                    break
                case 502:
                    message = 'Usuário não registrado'
                    modalData.value.error = true
                    break
                case 403:
                    if (this.toggleSocial) message = 'Usuário não registrado'
                    message = 'Opa, tem algo errado com seu e-mail ou sua senha! Reveja as informações.'
                    modalData.value.error = true
                    break
                case 504:
                    message = 'Acesso de usuário restrito'
                    modalData.value.error = true
                    break
                default:
                    modalData.value.show = false
            }

            modalData.value.message = message
        })
        .finally(() => (loading.value = false))
}

onMounted(() => {
    if (!plannerLoginData.value) return router.push('login')
})
</script>

<style lang="scss">
.clients {
    .header {
        @include flex-between();
    }

    .login-btn {
        text-transform: none !important;
        font-weight: 400 !important;
        color: white;
        background-color: $action-btn-color;
        font-size: 14px;
        display: flex;
        align-items: center;
        padding: 8px;
        height: 35px;
        width: 220px;
        text-align: center;
        position: relative;
        top: -4px;
        margin-left: 12px;
    }
}
</style>
